module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    directives: [{
      name: "on-clickaway",
      rawName: "v-on-clickaway",
      value: (_vm.away),
      expression: "away"
    }],
    staticClass: "btn-group multi-select btn-block",
    class: {
      'open': _vm.openSuggestion
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filter),
      expression: "filter"
    }],
    staticClass: "form-control multi-select-control",
    style: ({
      width: _vm.width || 'auto'
    }),
    attrs: {
      "type": "text",
      "placeholder": _vm.placeholder + ' ' + _vm.numberSelected
    },
    domProps: {
      "value": _vm._s(_vm.filter)
    },
    on: {
      "keyup": function($event) {
        _vm.open = true
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.filter = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.value.length) ? _c('button', {
    staticClass: "btn btn-delete",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.removeAll($event)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-remove"
  })]) : _vm._e(), _vm._v(" "), _c('ul', {
    staticClass: "dropdown-menu",
    class: _vm.size
  }, [_vm._l((_vm.value), function(l, i) {
    return _c('li', {
      on: {
        "click": function($event) {
          _vm.suggestionClick(l)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-check-square"
    }), _vm._v("\n                  \n                "), _c('span', {
      domProps: {
        "innerHTML": _vm._s(_vm.displaySelected(l))
      }
    })])
  }), _vm._v(" "), _vm._l((_vm.list), function(l, i) {
    return _c('li', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.filtered(l)),
        expression: "filtered(l)"
      }],
      on: {
        "click": function($event) {
          _vm.suggestionClick(l)
        }
      }
    }, [(!_vm.isSelected(l)) ? _c('i', {
      staticClass: "fa fa-square-o"
    }) : _vm._e(), _vm._v(" "), (_vm.isSelected(l)) ? _c('i', {
      staticClass: "fa fa-check-square"
    }) : _vm._e(), _vm._v("\n                  \n                "), _c('span', {
      domProps: {
        "innerHTML": _vm._s(_vm.display(l))
      }
    })])
  })], 2), _vm._v(" "), _c('button', {
    staticClass: "btn btn-trigger",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.toggleOpen($event)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-caret-down"
  })])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-41920df6!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/assets/MultiSelect.vue
// module id = 383
// module chunks = 0